import { AvailabilityResponse } from '~/contracts/vdp';

export default function normalizeAvailabilityResponse(
  response: AvailabilityResponse,
  userId?: string
): AvailabilityResponse {
  return {
    ...response,
    userId,
    vehicleAvailableDateTime: response.vehicleAvailableDateTime
      ? response.vehicleAvailableDateTime.replace(/Z?$/i, 'Z')
      : undefined
  };
}
